'use client'

import { useTransition } from 'react'

import { GlobeIcon } from 'lucide-react'

import { setLocale } from '@/app/actions/locale'
import { Button } from '@/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { LOCALES, LOCALE_LABELS, type Locale } from '@/types/website'

/** Хэл сонгогч — сонголтыг cookie-д хадгалж, серверээс дахин татна. */
const LocaleSwitcher = ({ locale }: { locale: Locale }) => {
  const [pending, startTransition] = useTransition()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button variant='ghost' size='sm' disabled={pending} className='gap-1.5'>
            <GlobeIcon className='size-4' />
            <span className='uppercase'>{locale}</span>
          </Button>
        }
      />
      <DropdownMenuContent align='end'>
        {LOCALES.map(code => (
          <DropdownMenuItem
            key={code}
            onClick={() => startTransition(() => setLocale(code))}
            className={code === locale ? 'font-medium' : undefined}
          >
            {LOCALE_LABELS[code]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default LocaleSwitcher
